module.exports = __webpack_public_path__ + "Profile204x300.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Profile204x300.jpg
// module id = 296
// module chunks = 0